module.exports = __webpack_public_path__ + "img/product-5-AGP.a49ec736.png";